import * as React from "react";
import "./MenuButton.component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
export function MenuButton({ icon = "ellipsis-v", text, size = "medium", menuTitle, menuPlacement = "bottom-right", closeOnSelect = true, options, buttonClassName, tooltip, tooltipDisabled, tooltipPosition = "bottom-right" }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [hasCheckables, setHasCheckables] = useState(false);
    const uuid = useRef(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
    useEffect(() => {
        setHasCheckables(options.some((option) => !option.divider && option.checked !== undefined));
    }, [options]);
    useEffect(() => {
        if (menuOpen) {
            // once: remove after exec to ensure the events don't get messed up
            // capture: ensure onWindowClicked is executed before onMenuButtonClicked (so we can stop the event if needed)
            window.addEventListener("click", onWindowClicked, {
                once: true,
                capture: true
            });
        }
    }, [menuOpen]);
    const onWindowClicked = (event) => {
        const menu = document.querySelector(".menu-button-menu");
        if (!menu) {
            return;
        }
        if (!menu.contains(event.target)) {
            setMenuOpen(false);
            const button = document.getElementById(uuid.current);
            if (button && button.contains(event.target)) {
                // we don't want to reopen again if the button of this instance was clicked, so we need to stop the event here
                // if it was the button of another instance, let the event pass to open the other menu
                event.stopPropagation();
            }
        }
        else {
            // Re-add the event listener if we did not close the menu
            window.addEventListener("click", onWindowClicked, {
                once: true,
                capture: true
            });
        }
    };
    const onOptionClicked = (option, event) => {
        var _a;
        event.stopPropagation();
        if ((_a = option.divider) !== null && _a !== void 0 ? _a : option.disabled) {
            return;
        }
        option.onClick();
        if (closeOnSelect) {
            window.removeEventListener("click", onWindowClicked);
            setMenuOpen(false);
        }
    };
    const onMenuButtonClicked = (event) => {
        event.stopPropagation();
        if (!menuOpen) {
            setMenuOpen(true);
        }
        else {
            window.removeEventListener("click", onWindowClicked);
            setMenuOpen(false);
        }
    };
    const createMenuOptions = () => options.map((option, index) => {
        var _a, _b;
        if (option.divider) {
            return React.createElement("div", { className: "menu-button-option-divider", key: index });
        }
        else {
            return (React.createElement("div", { className: `menu-button-option ${option.disabled ? "menu-button-option-disabled" : ""} ${(_a = option.className) !== null && _a !== void 0 ? _a : ""}`, onClick: (event) => {
                    onOptionClicked(option, event);
                }, key: index, "data-tooltip": option.disabled ? option.tooltipDisabled : option.tooltip, "data-tooltip-position": (_b = option.tooltipPosition) !== null && _b !== void 0 ? _b : tooltipPosition },
                option.icon && (React.createElement("div", { className: "menu-button-option-icon-container" },
                    React.createElement(FontAwesomeIcon, { icon: ["fas", option.icon] }))),
                React.createElement("span", null, option.text),
                hasCheckables && (React.createElement(React.Fragment, null,
                    React.createElement("div", { style: { flexGrow: 1 } }),
                    React.createElement(FontAwesomeIcon, { icon: ["fas", "check"], opacity: option.checked ? 1 : 0 })))));
        }
    });
    const getButtonClass = () => {
        let buttonClasses = "";
        if (!text) {
            if (size === "small") {
                buttonClasses = "icon-button-small";
            }
            else if (size === "large") {
                buttonClasses = "icon-button-large";
            }
            else {
                buttonClasses = "icon-button";
            }
        }
        if (buttonClassName) {
            buttonClasses += " " + buttonClassName;
        }
        return buttonClasses;
    };
    return (React.createElement("div", { className: "menu-button-container" },
        React.createElement("button", { className: getButtonClass(), onClick: onMenuButtonClicked, id: uuid.current, "data-tooltip": menuOpen ? "" : tooltip, "data-tooltip-disabled": menuOpen ? "" : tooltipDisabled, "data-tooltip-position": tooltipPosition },
            icon && React.createElement(FontAwesomeIcon, { icon: ["fas", icon] }),
            text && React.createElement("span", null, text)),
        menuOpen && (React.createElement("div", { className: "menu-button-menu menu-button-menu-" + menuPlacement },
            menuTitle && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "menu-button-menu-title" }, menuTitle),
                React.createElement("div", { className: "menu-button-option-divider" }))),
            createMenuOptions()))));
}
